import { Button } from "@/components/ui/button";
import { Menu } from "lucide-react";

/**
 * Slim top bar. Language switcher is now inside Login card; on dashboard
 * we keep only the mobile-drawer trigger. Client/company brand lives in the
 * Sidebar company card for bigger visibility.
 */
export default function TopBar({ onToggleSidebar }) {
  return (
    <div
      className="flex items-center justify-between gap-3 px-3 sm:px-6 md:px-8 py-3 sm:py-4 border-b border-border/60 bg-background/40 backdrop-blur-sm"
      data-testid="topbar"
    >
      <div className="flex items-center gap-2 min-w-0">
        <Button
          variant="ghost"
          size="icon"
          className="lg:hidden text-slate-300 hover:bg-[#1A1E2C]"
          onClick={onToggleSidebar}
          data-testid="sidebar-mobile-trigger"
          aria-label="Meni"
        >
          <Menu className="h-5 w-5" />
        </Button>
      </div>
      <div />
    </div>
  );
}
